// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"24":"2c20eecd","151":"7ca36b9d","213":"4dedbcff","437":"462ae8a3","474":"2ecfc860","897":"462ae8a3"}[chunkId] + ".css";
};